// Elements tab: one row per element with an SVG mini-preview. Rows select the
// element (view mode also pans to it when it's off-screen). In edit mode each
// row carries a lock toggle; locked rows can't be selected.

import { esc, elementLabel, elementSecondaryLabel } from './html';
import { elementThumbnail } from './thumbnails';
import { activeLayerFilter, matchesLayer, layerFilterHtml } from './filters';

function secondary(el, species) {
  const s = elementSecondaryLabel(el, species);
  return s ? ` <span class="pl2-row__sub">${esc(s)}</span>` : '';
}

export function elementsPanelHtml(state, { filter = '', layer = '', viewOnly = false } = {}) {
  const sel = new Set(state.selection);
  const q = filter.trim().toLowerCase();
  const lf = activeLayerFilter(state, layer);
  const shown = state.elements.filter((el) => matchesLayer(el, lf, state)
    && (!q || `${elementLabel(el, state.species)} ${elementSecondaryLabel(el, state.species)} ${el.type}`.toLowerCase().includes(q)));
  const rows = shown.map((el) => {
    const locked = !!el.data?.locked;
    const lockLabel = locked ? 'Unlock element' : 'Lock element';
    const lock = viewOnly ? '' : `<button class="pl2-iconbtn pl2-lockbtn" type="button" data-pl2="element-lock" data-id="${esc(el.id)}" title="${lockLabel}" aria-label="${lockLabel}">${locked ? '🔒' : '🔓'}</button>`;
    return `
    <div class="pl2-row ${sel.has(el.id) ? 'is-selected' : ''} ${locked ? 'is-locked' : ''}" data-pl2="element-select" data-id="${esc(el.id)}">
      ${elementThumbnail(el) || '<span class="pl2-row__swatch"></span>'}
      <span class="pl2-row__name">${esc(elementLabel(el, state.species))}${secondary(el, state.species)}</span>
      ${lock}
    </div>`;
  }).join('');
  const filtered = q || lf;
  const count = filtered ? `${shown.length} of ${state.elements.length}` : state.elements.length;
  const empty = filtered ? 'Nothing matches that filter.' : 'Nothing here yet.';
  return `
    <h3 class="pl2-section-title">Elements (${count})</h3>
    <input class="pl2-input pl2-filter" type="search" placeholder="Filter by name or type…" data-pl2="filter-elements" value="${esc(filter)}">
    ${layerFilterHtml(state, 'filter-elements-layer', lf)}
    ${rows || `<p class="pl2-muted">${empty}</p>`}`;
}
